<template>
    <div class="history_detail">
        <div class="history_detail_title">
            <p>历史明细查询 </p>
            <a
                style="margin-left: 10px;"
                title="低版本IE需手动加上.csv后缀"
                @click="exportHistory"
                >
                <vue-button type="blue" size="small">导出</vue-button>
            </a>
            <div class="history_day_select">
                <p>持股周期 :</p>
                <select class="day_select" v-model="currentday" @click="daySelects">
                    <option :value="item" v-for="(item, key, index) in dayselect" :key="key">{{ item }} 天</option>
                </select>
            </div>
            <div class="sd-toolbar_1">
                <div class="sd-toolbar_operabox_1">
                    <input id="history_detail_startDate" type="text" readonly="readonly" class="trade_detail_startDate_1" v-model="tradeStartDate" @click="showTradeDateDialog($event, '#F{$dp.$D(\'history_detail_endDate\')}', minDate)" @blur="startDatePoint">
                    <span class="time-split">&nbsp;至&nbsp;</span>
                    <input id="history_detail_endDate" type="text" readonly="readonly" class="trade_detail_endDate_1" v-model="tradeEndDate" @click="showTradeDateDialog($event, maxDate, '#F{$dp.$D(\'history_detail_startDate\')}')" @blur="endDatePoint">
                </div>
            </div>
        </div>
        <div class="history_detail_main">
            <table cellspacing="0">
                <thead>
                    <th>股票代码</th>
                    <th>股票简称</th>
                    <th>起始时间</th>
                    <th>终止时间</th>
                    <th>起始价</th>
                    <th>终止价</th>
                    <th>区间涨跌幅</th>
                </thead>
            </table>
            <EasyScrollbar :barOption="myBarOption">
                <div class="rolltable">
                    <table cellspacing="0">
                        <tbody>
                            <tr v-for="(hist, index) in historyList" :class="(index + 1) % 2 === 0 ? 'gray' : ''">
                                <td width="144">{{ hist.stock_code }}</td>
                                <td class="td-highlight" width="144" @click="codeLink(hist.stock_code)" @mouseenter="debounceShowQuoteChart($event, hist)" @mouseleave="hideQuoteChart(hist)">{{ hist.stock_name }}</td>
                                <td width="144">{{ hist.start_date }}</td>
                                <td width="144">{{ hist.end_date }}</td>
                                <td width="108">{{ hist.start_price | safeFloatFixedTwo }}</td>
                                <td width="109">{{ hist.end_price | safeFloatFixedTwo }}</td>
                                <td width="180" :class="hist.change_rate | riseAndFallClass">{{ hist.change_rate | safeFloatPerFixedTwo }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </EasyScrollbar>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-undef */
    /* eslint-disable no-new */
    import axios from 'axios'
    import {showTradeDateDialog} from '@/lib/wDatePicker.js'
    import exportCsv from '@/lib/exportCsv.js'
    import { safeFloatPerFixedTwo } from '@/filters'
    import quoteChart from '@/lib/quoteChartVue.js'
    import { debounce } from 'lodash'

    export default {
        props: {
            // 回测id
            backtestId: {
                type: String,
                required: true
            },
            // 周期
            period: {
                type: String,
                required: true
            },
            // 回测日期最大值
            maxDate: {
                type: String,
                required: true
            },
            // 回测日期最小值
            minDate: {
                type: String,
                required: true
            },
            // 滚动条配置
            myBarOption: {
                type: Object,
                required: true
            },
            // 周期可选值
            dayselect: {
                type: Array,
                required: true
            },
            refresh: Boolean
        },
        data () {
            var self = this
            var debounceShowQuoteChart = debounce(function () {
                // 鼠标还停留在dom上
                if (arguments[0].target.contains(self.$mousemoveEvent.target)) {
                    self.showQuoteChart(...arguments)
                }
            }, 1000)

            return {
                debounceShowQuoteChart,
                tradeStartDate: '',
                tradeEndDate: '',
                currentday: '',
                historyarr: [],
                inited: false
            }
        },
        computed: {
            historyList () {
                return this.filterHistory(this.historyarr.slice(0, 300))
            },
            buriedPoint () {
                return this.$buriedPoint.backtestOnce.history
            }
        },
        methods: {
            hideQuoteChart (item) {
                let code = item.stock_market.toLowerCase() + '_' + item.stock_code
                quoteChart.hide(code)
            },
            showQuoteChart (event, item) {
                let DOMRect = event.srcElement.getBoundingClientRect()
                let code = item.stock_market.toLowerCase() + '_' + item.stock_code
                quoteChart({
                    code,
                    top: DOMRect.top,
                    left: DOMRect.right - 30
                })
            },
            dataToCsvStr (historyList) {
                let csvStr = ''
                historyList.forEach((item) => {
                    csvStr += '\'' + item.stock_code + ',' + item.stock_name + ',' + item.start_date + ',' + item.end_date + ',' + item.start_price + ',' + item.end_price + ',' + safeFloatPerFixedTwo(item.change_rate) + '\n'
                })
                return csvStr
            },
            getFileName () {
                let date = new Date()
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                month = month < 10 ? '0' + month : month
                let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
                let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
                let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
                let second = date.getUTCSeconds() < 10 ? '0' + date.getUTCSeconds() : date.getUTCSeconds()
                let filename = '' + year + month + day + hour + minute + second
                return filename
            },
            filterHistory (arr) {
                var self = this
                return arr.filter(function (item) {
                    return Number(item.start_date) >= self.dateToNumber(self.tradeStartDate) && item.start_date <= self.dateToNumber(self.tradeEndDate)
                })
            },
            exportHistory () {
                let tableStr = ''
                let titleStr = '股票代码,股票简称,起始时间,终止时间,起始价,终止价,区间涨跌幅'
                let filename = this.getFileName()

                let historyList = this.filterHistory(this.historyarr)

                tableStr = this.currentday + '天\n' + titleStr + '\n' + this.dataToCsvStr(historyList)
                exportCsv(tableStr, filename)

                window.TA.log(this.buriedPoint.export)
            },
            startDatePoint () {
                window.TA.log(this.buriedPoint.startDate)
            },
            endDatePoint () {
                window.TA.log(this.buriedPoint.endDate)
            },
            daySelects () {
                window.TA.log(this.buriedPoint.cycleOption)
            },
            dateToNumber (date) {
                return Number(date.replace(/-/g, ''))
            },
            showTradeDateDialog,
            gethistorydetail: function () {
                var self = this
                return axios.get('/backtestonce/historydetail?sort_by=desc', {
                    params: {
                        id: this.backtestId,
                        start_date: this.tradeStartDate,
                        end_date: this.tradeEndDate,
                        period: Number(this.currentday)
                    }
                }).then((res) => {
                    if (res.data.result instanceof Array) {
                        self.historyarr = res.data.result
                    } else {
                        self.historyarr = []
                    }
                }).catch((error) => {
                    self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                })
            }
        },
        watch: {
            backtestId () {
                if (!this.inited) {
                    return
                }
                this.gethistorydetail()
            },
            currentday () {
                if (!this.inited) {
                    return
                }
                this.gethistorydetail()
            },
            period () {
                this.currentday = this.period
            },
            maxDate () {
                this.tradeEndDate = this.maxDate
            },
            minDate () {
                this.tradeStartDate = this.minDate
            },
            refresh () {
                this.currentday = this.period
            }
        },
        created () {
            this.currentday = this.period
            this.tradeStartDate = this.minDate
            this.tradeEndDate = this.maxDate
        },
        mounted () {
            this.gethistorydetail().finally(() => {
                this.inited = true
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .td-highlight {
        color: #3e76c2 !important;
        &:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }
    @import '../../scss/backtest/main.scss';
</style>



// WEBPACK FOOTER //
// src/components/backtest/history.vue